/*!
 * ETAR theme v4.2.4 — Footer "The last drop"
 * Developed by FACTICIED · https://www.facticied.com
 * Menus fold on phones; the store name is sized to fit and fills with gold as you reach the end of the page.
 * The gold only repaints while you scroll, so it costs nothing when the page is still.
 */
(() => {
  if (customElements.get('et-footer')) return;
  const mqMobile = window.matchMedia('(max-width: 749px)');

  class EtFooter extends HTMLElement {
    connectedCallback() {
      if (this._on) return; this._on = true;
      this.ac = new AbortController();
      const o = { signal: this.ac.signal };

      /* menus: always open on desktop, folded on phones */
      this.accs = Array.from(this.querySelectorAll('.et-ft__acc'));
      const sync = () => this.accs.forEach((d) => { d.open = !mqMobile.matches; });
      sync(); mqMobile.addEventListener('change', sync, o);
      this.accs.forEach((d) => d.querySelector('summary').addEventListener('click', (e) => { if (!mqMobile.matches) e.preventDefault(); }, o));

      this.querySelector('[data-top]')?.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }), o);
      this.querySelectorAll('[data-et-ft-loc] select').forEach((sel) => sel.addEventListener('change', () => sel.form.submit(), o));

      /* the store name */
      this.mark = this.querySelector('[data-mark]');
      this.text = this.querySelector('[data-mark-text]');
      if (!this.mark || !this.text) return;
      this.fit();
      if (window.ResizeObserver) { this.ro = new ResizeObserver(() => this.fit()); this.ro.observe(this.mark); }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.fit());

      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.fill !== 'scroll') return;
      if (reduce) { this.mark.style.setProperty('--f', 1); return; }
      const onScroll = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.pour(); }); };
      window.addEventListener('scroll', onScroll, { passive: true, signal: this.ac.signal });
      window.addEventListener('resize', onScroll, o);
      this.pour();
    }
    disconnectedCallback() { this.ac?.abort(); this.ro?.disconnect(); cancelAnimationFrame(this.raf); }

    /* make the word span the full width */
    fit() {
      const t = this.text, box = this.mark;
      const cs = getComputedStyle(box);
      const room = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (room <= 0) return;
      t.style.fontSize = '100px';
      const w = t.scrollWidth || t.getBoundingClientRect().width;
      if (!w) return;
      t.style.fontSize = Math.min(420, Math.max(40, (100 * room) / w)).toFixed(1) + 'px';
      this.pour && this.pour();
    }
    /* empty when the word appears, full when it is completely on screen */
    pour() {
      if (this.dataset.fill !== 'scroll' || !this.mark) return;
      const r = this.text.getBoundingClientRect(), vh = window.innerHeight;
      const atEnd = window.scrollY + vh >= document.documentElement.scrollHeight - 4;
      let f = (vh - r.top) / (r.height * 1.6);
      if (atEnd) f = Math.max(f, 1);
      f = Math.max(0, Math.min(1, f));
      this.mark.style.setProperty('--f', f.toFixed(3));
      /* the surface sways a little as you scroll, so the perfume feels liquid */
      this.mark.style.setProperty('--wx', ((window.scrollY * 0.35) % 56).toFixed(1) + 'px');
    }
  }
  customElements.define('et-footer', EtFooter);
})();
